import { type Accept } from 'react-dropzone'

export const HEIC_ACCEPT: Accept = {
  'image/heic': ['.heic'],
  'image/heif': ['.heif']
}

const HEIC_JPEG_QUALITY = 0.9

const HEIC_MIME_TYPES = ['image/heic', 'image/heif']
const HEIC_EXTENSION = /\.hei[cf]$/i

// Chrome on Windows and Linux reports an empty file.type for .heic, so the
// extension is the only reliable signal there.
export const isHeicFile = (file: File): boolean =>
  HEIC_MIME_TYPES.includes(file.type.toLowerCase()) || HEIC_EXTENSION.test(file.name)

/**
 * Returns the file unchanged unless it is HEIC, in which case it is decoded to a
 * JPEG File. The decoder is a ~3MB wasm bundle, so only HEIC uploads load it.
 */
export const toUploadableImage = async (file: File): Promise<File> => {
  if (!isHeicFile(file)) return file

  const { heicTo } = await import('heic-to')
  const blob = await heicTo({ blob: file, type: 'image/jpeg', quality: HEIC_JPEG_QUALITY })
  const name = HEIC_EXTENSION.test(file.name) ? file.name.replace(HEIC_EXTENSION, '.jpg') : `${file.name}.jpg`

  return new File([blob], name, { type: 'image/jpeg', lastModified: file.lastModified })
}
